import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const GraButton = styled(Link)<{ isDarkMode: boolean }>`
  width: 92px;
  height: 36px;
  background: ${({ isDarkMode }) =>
    isDarkMode ? 'rgba(0, 122, 255, 0.1)' : 'rgba(255, 255, 255, 0.1)'};
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? '#007aff' : '#1A5BE5')};
  font-size: 14px;
  font-weight: 500;
  color: ${({ isDarkMode }) => (isDarkMode ? '#007aff' : '#1A5BE5')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
    background: ${({ isDarkMode }) =>
      isDarkMode ? '#007aff' : '#1A5BE5'};
    color: white;
  }

  &:active {
    transform: translateY(0);
  }
`;
